import SavedProfile from "../../components/SavedProfile";


export default function SavedProfilePage() {
    return (
        <SavedProfile />
    )
};